<mat-checkbox [formControlName]="controlName" class="mat-option" [disableRipple]="true" (change)="toggleSelection($event)">
  {{text}}
</mat-checkbox>
